import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { SessionAnalyticsComponent } from '@go-modules/components/feedback-session/session-analytics/session-analytics.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { NgxZeroStateModule } from '@go-modules/components/zero-state/zero-state.module';
import { HighchartsChartComponent, provideHighcharts } from 'highcharts-angular';
import { FeedbackGraphComponent } from './feedback-graph/feedback-graph.component';
import { MarkerDisplayModule } from '@go-modules/components/marker-display/marker-display.module';
import { FormatTimeModule } from '@go-modules/pipes/format-time/format-time.module';
import { PaceMetricGraphComponent } from './pace-metric-graph/pace-metric-graph.component';
import { WordMetricGraphComponent } from './word-metric-graph/word-metric-graph.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { SessionAnalyticItemViewComponent } from './session-analytic-item-view/session-analytic-item-view.component';
import { PauseMetricGraphComponent } from './pause-metric-graph/pause-metric-graph.component';
import { AnalyticGraphZeroStateComponent } from './analytic-graph-zero-state/analytic-graph-zero-state.component';
import { TeaseWallModule } from '@go-modules/directives/tease-wall/tease-wall.module';
import { GoSelectModule } from '@go-modules/directives/go-select/go-select.module';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { BadgeModule } from '@go-modules/components/badge/badge.module';
import { FeedbackDisplayHeaderComponent } from '../feedback-display-header/feedback-display-header.component';
import { GoCdkPopoverDirective } from '@go-modules/directives/go-cdk-popover/go-cdk-popover.directive';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		NgxZeroStateModule,
		HighchartsChartComponent,
		MarkerDisplayModule,
		FormatTimeModule,
		MatExpansionModule,
		TeaseWallModule,
		GoSelectModule,
		MatSelectModule,
		FormsModule,
		BadgeModule,
		FeedbackDisplayHeaderComponent,
		GoCdkPopoverDirective
	],
	exports: [
		SessionAnalyticsComponent,
		PauseMetricGraphComponent,
		FeedbackGraphComponent,
		PaceMetricGraphComponent,
		SessionAnalyticItemViewComponent
	],
	declarations: [
		SessionAnalyticsComponent,
		PauseMetricGraphComponent,
		FeedbackGraphComponent,
		PaceMetricGraphComponent,
		WordMetricGraphComponent,
		SessionAnalyticItemViewComponent,
		AnalyticGraphZeroStateComponent
	],
	providers: [
		provideHighcharts(),
		TranslatePipe
	]
})
export class SessionAnalyticsModule {}
